import { QuestionnaireQuestion } from "./questionnaire_question";
import { Model } from "./model";

export class Questionnaire extends Model {
	private label: string = "";
	private questions: QuestionnaireQuestion[] = [];

	public getLabel(): string {
		return this.label;
	}

	public getQuestions(): QuestionnaireQuestion[] {
		return this.questions;
	}

	public setQuestions(list: QuestionnaireQuestion[]): void {
		this.questions = list;
	}
}
